import styled from "styled-components";

export const Container = styled.div`
  // background-color: green;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;

  @media(max-width: 768px){
    height: auto;
    width: 100%;
    align-self: center;
  }
`;

export const Wish = styled.div`
// background-color: blue;
width: 400px;
align-items: left;
padding-top: 20px;
padding-bottom: 20px;
// border: 1px solid #0E8FD8;
gap: 10px;
margin-left: 20px;
margin-right: 20px;
display: none;


@media (max-width: 769px){
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80vw;
    gap: 5px;
    margin-bottom: 30px;
}
`;
export const WishHeader = styled.div`
font-family: Kanit;
font-weight: 900;
font-size: 36px;
letter-spacing: 5px;
// color: #056988;
color: #000000;

@media (max-width: 769px){
  text-align: center;
    margin-bottom: 5px;
    letter-spacing: none;
    font-size: 20px;
    font-weight: 700;
}
`;
export const WishDesc = styled.div`
font-family: Kanit;
font-size: 16px;
color: #grey;
// color: #056988;
text-align: left;
text-align: justify;
// text-justify: inter-word;
text-justify: auto;
line-height: 22px;

@media (max-width: 769px){
  // background: red;
    margin-bottom: 20px;
}
`;
export const WishFooter = styled.div`
font-family: Kanit;
font-size: 18px;
text-transform: uppercase;
letter-spacing: 1px;
color: #D80E0E;
font-weight: 900;

@media (max-width: 768px){
    margin-top: 0px;
    text-align: center;
}
`;

export const Hero = styled.video`
  width: 60%;
  height: 90%;
  object-fit: cover;
  z-index: -1;

  @media(max-width: 768px){
    display: none;
      width: 60%;
      height: auto;
  }
  @media(max-width: 600px){
    display: none;
      width: 90%;
  }
  @media(max-width: 425px){
    display: none;
      width: 90%;
  }
`;

export const Wrapper = styled.div`
width: 100%;
height: 100%;
// background-color: green;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
position: absolute;
color: white;
padding-top: 30px;
font-family: Poppins;

@media(max-width: 768px){
  display: none;
  padding-top: 30px;
}
`;

export const Info = styled.div`
color: white;
font-size: 40px;
font-family: Kanit;

@media(max-width: 768px){
font-size: 20px;
letter-spacing: 0.3px;
}
`;
export const Info1 = styled.p`
font-family: Kanit;
font-size: 60px;
font-weight: bold;
margin-bottom: 0px;
letter-spacing: 10px;
/* background-color: #f69928; */

@media(max-width: 768px){
  font-size: 40px;
  letter-spacing: 0.3px;
  }
`;

export const Info2 = styled.p`
font-family: Kanit;
font-size: 60px;
font-weight: bold;
letter-spacing: 10px;
/* background-color: #f69928; */

@media(max-width: 768px){
  font-size: 40px;
  letter-spacing: 0.3px;
  }
`;